import React from 'react'
// utils
import { cn } from '@utils/cn'

// types
import type { children, className } from './types'

export interface DialogHeaderProps extends React.ComponentProps<'div'> {
  className?: className
  children: children
}

export const DialogHeader = React.forwardRef<HTMLDivElement, DialogHeaderProps>(({ className, children, ...rest }, ref) => {
  // 3. set styles
  const baseClasses = 'flex items-center shrink-0 p-4 text-blue-gray-900 antialiased font-sans text-2xl font-semibold leading-snug'
  const dialogHeaderClasses = cn(baseClasses, className)

  // 4. return
  return (
    <div {...rest} ref={ref} className={dialogHeaderClasses}>
      {children}
    </div>
  )
})

DialogHeader.displayName = 'DialogHeader'

export default DialogHeader




